// extracted by mini-css-extract-plugin
export default {"menu":"BurgerMenu_menu__EerBP","button":"BurgerMenu_button__5zUkh","close-button":"BurgerMenu_close-button__vafFc"};